import { Container } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { deleteDeath, getDeath, restoreDeath, updateDeath } from "../../../api";
import EditNewsForm from "../../EditNewsForm";

export default function EditDeath() {
  const location = useLocation();
  const navigate = useNavigate();

  const customSubmitFunction = async (id, title, description, image) => {
    try {
      const result = await updateDeath(id, title, description, image);
      if (result) {
        navigate("/death/all");
      }
    } catch (error) {}
  };

  const publishDeath = async (id) => {
    try {
      await restoreDeath(id);

      navigate("/death/all");
    } catch (error) {}
  };
  const unPublishDeath = async (id) => {
    try {
      await deleteDeath(id);

      navigate("/death/all");
    } catch (error) {
      throw error;
    }
  };

  const getOneDeath = async (id) => {
    try {
      const result = await getDeath(id);
      return result;
    } catch (error) {
      throw error;
    }
  };

  return (
    <>
      <Container>
        <EditNewsForm
          ItemId={location?.state?.deathId}
          breadCrumbLink={"Deaths"}
          breadCrumbText={"Edit Death"}
          goBackLink={"/death/all"}
          customsubmit={customSubmitFunction}
          publishItem={publishDeath}
          unPublishItem={unPublishDeath}
          getOneItem={getOneDeath}
        />
      </Container>
    </>
  );
}
